import { RequestMethod, RequestName, RequestProxy, useCaller } from '~/hydration/bridges';
import type { UsersResponse } from '~/units/users/types';

export class UsersService {
  async fetchUsers(query = {}): Promise<any> {
    try {
      return await useCaller(
        RequestProxy.LS_AXON,
        RequestName.FETCH_USERS,
        'users',
        RequestMethod.GET,
        {
          __limit: 250,
          __order_by: 'name',
          ...query,
        },
        {},
      );
    } catch (e) {
      return {
        data: [],
        meta: { total: 0 },
      };
    }
  }
} 